import { createSlice } from '@reduxjs/toolkit'

const boardList = createSlice({
    name: 'boardList',
    initialState: {
        list: [],
        list_loaded: false
    },
    reducers: {
        load(state, action) {
            state.list = action.payload.list;
            state.list_loaded = true;
        },
        add(state, action) {
            state.list = [...state.list, action.payload.model].sort((a, b) => a.Order - b.Order);
        },
        update(state, action) {
            const model = action.payload.model;

            if (model.Archive === true) {
                state.list = [...state.list.filter(a => a.ID !== model.ID)].sort((a, b) => a.Order - b.Order);
            }
            else {
                state.list = [...state.list.filter(a => a.ID !== model.ID), model].sort((a, b) => a.Order - b.Order);
            }
        },

    }
})

export const { load, add, update, orderChange } = boardList.actions
export default boardList.reducer